import { render, staticRenderFns } from "./DataLoggerFormTemplate.vue?vue&type=template&id=4b644950&scoped=true&"
import script from "./DataLoggerFormTemplate.vue?vue&type=script&lang=ts&"
export * from "./DataLoggerFormTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b644950",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VContainer,VForm,VSwitch})
